import React from 'react'

const linkClass =
  'text-sm font-medium text-[color:var(--theme-fg)] transition-colors duration-fast ease-out-soft hover:text-[color:var(--theme-brand-text)]'

interface SiteFooterProps {
  /** Extra classes for the surrounding element, so each shell can set its own spacing. */
  className?: string
}

/**
 * Legal and navigation links for the React shells (auth pages and the dashboard).
 * The public ERB layout renders the richer shared/_site_footer partial instead;
 * keep the link set of the two in step.
 */
export function SiteFooter({ className = '' }: SiteFooterProps) {
  return (
    <footer className={`border-t border-[color:var(--theme-border-soft)] ${className}`}>
      <div className="mx-auto flex w-full max-w-7xl flex-col gap-3 py-6 sm:flex-row sm:items-center sm:justify-between">
        <p className="text-xs text-[color:var(--theme-muted)]">
          &copy; {new Date().getFullYear()} LodgeLink
        </p>

        <nav aria-label="Footer" className="flex flex-wrap items-center gap-x-8 gap-y-2">
          <a href="/find-a-lodge" className={linkClass}>
            Find a lodge
          </a>
          <a href="/privacy" className={linkClass}>
            Privacy policy
          </a>
          <a href="/terms" className={linkClass}>
            Terms of service
          </a>
        </nav>
      </div>
    </footer>
  )
}
